SectorAccount<template>
  <v-flex md7>
    <page-toolbar>
      <kendo-button icon="add" title="Add new" @click="addRecord" v-if="!isReadOnly">
      </kendo-button>
    </page-toolbar>
    <kendo-grid
      height="calc(100vh - 145px)"
      :dataSource="dataSource"
      :editable="!isReadOnly && 'inline'"
      ref="grid"
      :filterable="true"
      :sortable="true"
      :pageable-always-visible="true"
      :columns="columns"
    >
    </kendo-grid>
  </v-flex>
</template>
<script>
import {mapGetters} from 'vuex'
import {jsonDropDownEditor} from '@/helpers/kendo-editors'
import PageToolbar from '@/components/PageToolbar'
import {enableExportExcel} from '@/helpers/export-helper'
import security from '@/mixins/security'

const $ = kendo.jQuery

export default {
  mixins: [security],
  mounted() {
    let grid = this.$refs.grid.kendoWidget()
    enableExportExcel(grid, '/api/heroux/SectorAccount/exportToExcel', $('.page_toolbar-item'))
  },
  data() {
    return {
      dataSource: new kendo.data.DataSource({
        type: 'aspnetmvc-ajax',
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        pageSize: 30,
        transport: {
          read: {
            type: 'GET',
            url: '/api/heroux/SectorAccount',
            data: () => ({clientId: this.clientId}),
            dataType: 'json',
          },
          create: {
            type: 'POST',
            url: '/api/heroux/SectorAccount',
            dataType: 'json',
          },
          update: {
            type: 'PUT',
            url: '/api/heroux/SectorAccount',
            dataType: 'json',
          },
          destroy: {
            type: 'DELETE',
            url: '/api/heroux/SectorAccount',
            dataType: 'json',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'sectorAccountId',
            fields: {
              sectorAccountId: {type: 'number', defaultValue: -1},
              clientId: {type: 'number', defaultValue: () => this.clientId},
              sectorId: {type: 'number'},
              divisionId: {type: 'number'},
              division: {type: 'string', validation: {required: true}},
              counterpartyId: {type: 'number'},
              counterparty: {type: 'string', validation: {required: true}},
              accountNumber: {type: 'string', validation: {required: true}},
              ccy: {type: 'string', validation: {required: true}},
              canBeDeleted: {type: 'bool', defaultValue: true, editable: false},
            },
          },
        },
      }),
    }
  },
  methods: {
    addRecord() {
      let grid = this.$refs.grid.kendoWidget()
      grid.addRow()
    },
    divisionDropDownEditor(container, options) {
      return jsonDropDownEditor(
        'divisionId',
        'division',
        '/api/heroux/SectorAccount/getDivisions?clientId=' + this.clientId,
        {
          dataBound: function() {
            this.trigger('change')
          },
        },
        true,
      )(container, options)
    },
    counterpartyDropDownEditor(container, options) {
      return jsonDropDownEditor(
        'counterpartyId',
        'counterparty',
        '/api/heroux/SectorAccount/getCounterparties?clientId=' + this.clientId,
        {
          dataBound: function() {
            this.trigger('change')
          },
        },
        true,
      )(container, options)
    },
    ccyDropDownEditor(container, options) {
      return jsonDropDownEditor(
        'ccy',
        'ccy',
        '/api/heroux/SectorAccount/getCcies?clientId=' + this.clientId,
        {
          dataBound: function() {
            this.trigger('change')
          },
        },
        true,
      )(container, options)
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    columns() {
      return [
        {
          editable: !this.isReadOnly,
          command: [{name: 'edit'}],
          width: 40,
        },
        {
          field: 'division',
          title: 'Division',
          width: 120,
          headerAttributes: {
            style:
              'overflow:visible; white-space: normal; text-align: center; font-size:12px; vertical-align:middle;',
          },
          attributes: {style: 'text-align: left;'},
          editor: this.divisionDropDownEditor,
          template: '#=division#',
        },
        {
          field: 'counterparty',
          title: 'Counterparty',
          width: 100,
          headerAttributes: {
            style:
              'overflow:visible; white-space: normal; text-align: center; font-size:12px; vertical-align:middle;',
          },
          attributes: {style: 'text-align: left;'},
          editor: this.counterpartyDropDownEditor,
          template: '#=counterparty#',
        },
        {
          field: 'ccy',
          title: 'Ccy',
          width: 70,
          headerAttributes: {
            style:
              'overflow:visible; white-space: normal; text-align: center; font-size:12px; vertical-align:middle;',
          },
          attributes: {style: 'text-align: left;'},
          editor: this.ccyDropDownEditor,
          template: '#=ccy#',
        },
        {
          field: 'accountNumber',
          title: 'Account Number',
          width: 200,
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: left;'},
          editor:
            '<input name="accountNumber" required="required" type="text" class="k-input k-textbox" data-bind="value:accountNumber" />',
        },
        {
          editable: !this.isReadOnly,
          command: [{name: 'destroy', visible: dataItem => dataItem.canBeDeleted}],
          width: 40,
        },
      ].filter(c => c.editable !== false)
    },
  },
  components: {
    PageToolbar,
  },
}
</script>
